import Config from "../config/env.js";
/**
 * @method executeRequest simplifies fetching data and adds host name for all request urls!
 */
export default async function executeRequest(url, method, data, signal) {
    const reqBody = method == "POST" || method == "PATCH" || method === "PUT" || method === "DELETE" ?
        JSON.stringify(data)
        : undefined;
    const response = await fetch(Config.devAdress + url, {
        method: method,
        credentials: "include",
        headers: {
            "Content-type": "application/json",
        },
        body: reqBody,
        cache: "no-cache",
        signal,
    });
    return await response.json();
}
